import block from 'bem-cn';
import './footer.scss';

const b = block('footer');

export function Footer() {
  return <footer className={b()}>Copyright © 2023 WeWork Companies Inc. All rights reserved</footer>;
}
